<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="ts-flex ts-item-end">
        <ts-input
          v-tooltip="$t('productProfile.saleInvoiceSearch')"
          v-model="search"
          :placeholder="$t('productProfile.saleInvoiceSearch')"
          style="width: 100%;"
          class="inline-block"
        />
      </div>
      <div class="overflow-auto ts-mt-3">
        <ts-table :columns="columns" :records="resources" :loading="loading">
          <template v-slot="{ record }">
            <td>{{ record.branch_name_en }}</td>
            <td>{{ record.invoice_no }}</td>
            <td>{{ record.customer_name }}</td>
            <td class="text-right">{{ $currencyFormat(record.sub_total) }}</td>
            <td class="text-right">{{ $currencyFormat(record.discount) }}</td>
            <td class="text-right">{{ $currencyFormat(record.vat_amount) }}</td>
            <td class="text-right">{{ $currencyFormat(record.amount_paid) }}</td>
            <td class="text-right">{{ $currencyFormat(record.amount_due) }}</td>
            <td>{{ record.next_payment_date }}</td>
            <td class="ts-text-center">
              <span class="badge badge-success" v-if="record.is_paid">Yes</span>
              <span class="badge badge-danger" v-else>No</span>
            </td>
            <td>{{ record.name }}</td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-between align-items-center p-15">
        <ts-total-list v-model="pagination" />
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { debounce } from 'lodash'
export default {
  name: 'transferReceived',
  data() {
    return {
      loading: false
    }
  },
  computed: {
    ...mapState('product/productDetailSaleInvoice', [
      'resources',
      'pagination'
    ]),
    search: {
      get() {
        return this.$store.state.product.productDetailSaleInvoice.search
      },
      set(newValue) {
        this.$store.commit(
          'product/productDetailSaleInvoice/SET_SEARCH',
          newValue
        )
        this.$store.commit(
          'product/productDetailSaleInvoice/RESET_CURRENT_PAGE'
        )
      }
    },
    columns() {
      return [
        { name: this.$t('productProfile.branchName'), style: 'width: 7%' },
        { name: this.$t('productProfile.invoice#') },
        { name: this.$t('productProfile.customerName') },
        { name: this.$t('productProfile.subTotal'), style: 'text-align:right' },
        { name: this.$t('productProfile.discount'), style: 'text-align:right' },
        { name: this.$t('productProfile.vatAmount'), style: 'text-align:right' },
        { name: this.$t('productProfile.amountPaid'), style: 'text-align:right' },
        { name: this.$t('productProfile.amountDue'), style: 'text-align:right' },
        { name: this.$t('productProfile.nextPaymentDate') },
        {
          name: this.$t('productProfile.isPaid'),
          style: 'text-align:center'
        },
        { name: this.$t('productProfile.cratedBy') }
      ]
    }
  },
  methods: {
    ...mapActions('product/productDetailSaleInvoice', ['fetch']),
    fetchData() {
      this.loading = true
      this.fetch(this.$route.params.id)
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  watch: {
    search: debounce(function() {
      this.fetchData()
    }, 500)
  }
}
</script>
